import ko from 'knockout';
import { CompetentionQualityType as QualityType } from './qualityType';
import { customFetch as fetch } from '../fetch';
import { SelectPicker } from '../custom-packages/choicesjs/selectPicker';

export async function getAllQualityTypes() {
    const response = await fetch('/Admin/QualityType/All');
    return response.data;
}

export class CompetentionModel {
    id: KnockoutObservable<string>;
    competention: KnockoutObservable<string>;
    examDuration: KnockoutObservable<number>;
    examDescription: KnockoutObservable<string>;
    employerDescription: KnockoutObservable<string>;
    examQuestionAmount: KnockoutObservable<number>;
    examOrder: KnockoutObservable<number>;
    selectedQualityTypes: KnockoutObservableArray<SelectPicker>;

    qualityTypes: QualityType[];

    constructor(model: any = {}, parentModel: any, qualityTypes: QualityType[]) {
        this.qualityTypes = qualityTypes;

        this.selectedQualityTypes = ko.observableArray<SelectPicker>((model.qualityTypeIds || []).map((qt: any) => ({ value: qt })));
        this.id = ko.observable<string>(model.competentionId || '')
            .extend({
                errorHandler: { source: parentModel.validationErrors, id: 'Id' }
            });

        this.competention = ko.observable<string>(model.competention || '')
            .extend({
                errorHandler: { source: parentModel.validationErrors, id: 'Competention' }
            });

        this.examDuration = ko.observable<number>(model.examDuration || 0)
            .extend({
                errorHandler: { source: parentModel.validationErrors, id: 'ExamDuration' }
            });

        this.examDescription = ko.observable<string>(model.examDescription || '')
            .extend({
                errorHandler: { source: parentModel.validationErrors, id: 'ExamDescription' }
            });

        this.employerDescription = ko.observable<string>(model.employerDescription || '');

        this.examQuestionAmount = ko.observable<number>(model.examQuestionAmount || '')
            .extend({
                errorHandler: { source: parentModel.validationErrors, id: 'ExamquestionAmount' }
            });
        
        this.examOrder = ko.observable<number>(model.examOrder || 1)
            .extend({
                errorHandler: { source: parentModel.validationErrors, id: 'ExamOrder' }
            });
    }
}
